import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

const HANDLE = '.amba-sortable-handle';
const GHOST = 'amba-sortable-ghost';

// Author-defined report sections on the config form: add/remove rows and
// drag-to-reorder, renumbering the hidden `position` inputs so the order is submitted
// with the single config form (no per-row server round-trip).
export default class extends Controller {
  static targets = ['list', 'row', 'template'];

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      ghostClass: GHOST,
      handle: HANDLE,
      onUpdate: () => this.renumber(),
    });
    this.renumber();
  }

  disconnect() {
    if (this.sortable) this.sortable.destroy();
  }

  add(event) {
    event.preventDefault();
    const html = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime().toString()
    );
    this.listTarget.insertAdjacentHTML('beforeend', html);
    this.renumber();
    const added = this.listTarget.lastElementChild;
    const input = added && added.querySelector('input[type="text"], textarea');
    if (input) input.focus();
  }

  remove(event) {
    event.preventDefault();
    const row = event.currentTarget.closest(
      '[data-ai-report-sections-target="row"]'
    );
    if (!row) return;

    const destroy = row.querySelector(
      '[data-ai-report-sections-target="destroy"]'
    );
    const persisted = row.querySelector('input[name*="[id]"]');
    if (persisted && destroy) {
      // Existing row: flag for destruction + hide (submitted so the server deletes it).
      destroy.value = '1';
      row.classList.add('d-none');
    } else {
      // Never-saved row: just drop it.
      row.remove();
    }
    this.renumber();
  }

  // Number the still-present rows 1..n so `position` reflects the on-screen order.
  renumber() {
    let index = 0;
    this.rowTargets.forEach((row) => {
      if (row.classList.contains('d-none')) return;
      const position = row.querySelector(
        '[data-ai-report-sections-target="position"]'
      );
      if (position) position.value = (index + 1).toString();
      index += 1;
    });
  }
}
